export namespace MQ {
  export const forMobile = '(min-width: 320px) and (max-width: 767px)';
  export const forTablet = '(min-width: 768px) and (max-width: 1023px)';
  export const forMedium = '(min-width: 1024px) and (max-width: 1199px)';
  export const forLarge = '(min-width: 1200px)';
}
